import { connectPagination, Pagination } from 'react-instantsearch-dom'
import PropTypes from 'prop-types'

const CustomPagination = ({ nbPages }) => {
    return <>{nbPages < 2 ? null : <Pagination padding={1} />}</>
}
export default connectPagination(CustomPagination)

CustomPagination.propTypes = {
    nbPages: PropTypes.number,
}
